import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";

import HNSColors from "../../../../../ui library/HNSColors";
import { useProviderSearchStore } from "../../store/providerSearchStore";
import DataNotFoundContainer from "../DataNotFoundContainer";

import ProviderTable from "./ProviderTable";

export default function ProviderList({ onClickProviderDetail }) {
  const store = useProviderSearchStore();
  const [displayedData, setDisplayedData] = useState(store.data);

  useEffect(() => {
    setDisplayedData(store.data);
    store.setMapDisplayData(store.data);
  }, [store.data]);

  const handleSelect = (row) => {
    setDisplayedData([row]);
    store.setMapDisplayData([row]);
    store.setDisableSaveButton(false);
    store.setAssignedProvider(row);
    store.setSelectedCenter({lat:row?.address?.latitude, lng:row.address.longitude});
  };

  const handleDeselect = () => {
    store.setDisableSaveButton(true);
    store.setMapDisplayData(store.data);
    setDisplayedData(store.data);
    store.setAssignedProvider(null);
    store.setSelectedCenter(null);
  };

  const handlePageChange = (_, newPage) => store.setCurrentPage(newPage);

  if (store.loading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <CircularProgress style={{ color: HNSColors.secondary[500] }} />
      </div>
    );
  }

  if (!displayedData?.length) {
    return <div className="w-full h-full relative"><DataNotFoundContainer /></div>;
  }

  return (
    <ProviderTable
      displayedData={displayedData}
      assignedProvider={store.assignedProvider}
      data={store.data}
      resultCount={store.resultCount}
      currentPage={store.currentPage}
      resLimit={store.resLimit}
      handlePageChange={handlePageChange}
      onClickDetail={onClickProviderDetail}
      onSelect={handleSelect}
      onDeselect={handleDeselect}
      address={store.address}
      initAddress={store.initAddress}
    />
  );
}
